
export const CreateChartsContext = () => {
  return { dates: [], ts: [] };
};
